import * as React from "react";
import { Context } from "./_context";
export const CategoryToysIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 11a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm6-6H6.347l-.253 1.515 9.327 5.995a5 5 0 1 1-1.083 1.682L4.459 7.84a1 1 0 0 1-.445-1.005l.5-3 .018-.089A1 1 0 0 1 5.5 3H11v2Zm-6 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm14 0c-.693 0-1.33.237-1.837.63l2.378 1.53-1.082 1.68-2.378-1.527A3 3 0 1 0 19 13Zm1-4h-6V7h6v2Z", fill: "currentColor" }));
  return iconset[size];
};
CategoryToysIcon.iconId = "aqT77q";
